<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgements"><br/><br/><br/><br/><br/><br/>
<p>How a Lancashire lad from humble beginnings took the long, tricky, hard and difficult road to achieve his ambition of becoming a Member of Parliament.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?786c4542